<app-layer-details-copy-button (copyClicked)="copyClicked.emit()"></app-layer-details-copy-button>
<app-layer-details-position [position]="layer | rectCenter"></app-layer-details-position>
<app-layer-details-geolocation [position]="layer | rectCenter"></app-layer-details-geolocation>
<app-layer-details-orientation
  [azimuth]="layer.data.azimuth"
  [verticalTilt]="layer.data.verticalTilt"
></app-layer-details-orientation>
